if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('express-cart-warning.js')) {
  window.Eurus.loadedScript.add('express-cart-warning.js');

  var registerExpressCartWarning = function () {
    Alpine.data('xExpressCartWarning', (variant, autoShow) => ({
      show: false,
      loading: false,
      removing: false,
      unavailableItems: [],
      config: window.haomaExpressCartWarningConfig || {},
      variant: variant || 'inline',
      alwaysAutoShow: autoShow === true,
      previousCep: '',
      warnedCepKey: 'haoma-express-cart-warning-cep',
      acceptedCepKey: 'haoma-express-cart-warning-accepted',
      gateId: 'express-warning-' + (++window.__haomaExpressGateSeq || (window.__haomaExpressGateSeq = 0)),
      gateHeld: false,
      lastValidationTrigger: 'init',
      cartChangeTimer: null,
      validationToken: 0,

      init() {
        this.previousCep = this.getWarnedCep();

        window.addEventListener('haoma:cep-updated', () => {
          this.lastValidationTrigger = 'cep-updated';
          this.onCepUpdated();
        });

        document.addEventListener('eurus:cart:items-changed', () => {
          this.scheduleCartValidationFromItemsChanged();
        });

        // Ao adicionar produto, força revalidação com abertura do aviso,
        // mesmo que o usuário já tenha dispensado no mesmo CEP.
        document.addEventListener('eurus:product:added', () => {
          this.lastValidationTrigger = 'product-added';
          this.holdGate();
          var self = this;
          setTimeout(function () {
            self.validateCart(true);
          }, 120);
        });

        window.addEventListener('eurus:cart:items-changed', () => {
          this.scheduleCartValidationFromItemsChanged();
        });

        if (this.config.enabled && this.getSavedCep()) {
          this.holdGate();
          this.validateCart(false);
        }
      },

      applyForceStandard(on, scope) {
        if (window.haomaExpressAvailability && typeof window.haomaExpressAvailability.setForceStandard === 'function') {
          window.haomaExpressAvailability.setForceStandard(on, scope);
        } else if (scope === 'cart') {
          window.haomaForceStandardDeliveryCart = !!on;
        } else {
          window.haomaForceStandardDelivery = !!on;
        }
      },

      // Persiste no atributo do carrinho (sobrevive a navegação) e aplica
      // imediatamente as badges de entrega padrão em toda a loja.
      async forceStandardDelivery(on) {
        try {
          await fetch(Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _entrega_forcada: on ? 'padrao' : '' } })
          });
        } catch (e) {
          /* ignore */
        }
        this.applyForceStandard(on);
      },

      async maybeClearForceStandard(cart) {
        this.clearAccepted();
        try {
          sessionStorage.removeItem(
            this.config.dismissStorageKey || 'haoma-express-cart-warning-dismissed'
          );
        } catch (e) {
          /* ignore */
        }

        // Sem itens fora da expressa, o pedido volta a ser elegível: limpa o
        // force (carrinho + loja) para as badges express reaparecerem.
        if (cart && cart.attributes && cart.attributes._entrega_forcada === 'padrao') {
          await this.forceStandardDelivery(false);
        } else {
          this.applyForceStandard(false, 'cart');
          this.applyForceStandard(false);
        }
      },

      // O aceite vale por CEP: enquanto ele estiver registrado o aviso não
      // reabre a cada produto adicionado, mesmo com SKU novo no carrinho.
      isAcceptedForCep(cep) {
        try {
          var saved = sessionStorage.getItem(this.acceptedCepKey);
          return !!saved && saved === String(cep || '');
        } catch (e) {
          return false;
        }
      },

      markAccepted(cep) {
        try {
          sessionStorage.setItem(this.acceptedCepKey, String(cep || ''));
        } catch (e) {
          /* ignore */
        }
      },

      clearAccepted() {
        try {
          sessionStorage.removeItem(this.acceptedCepKey);
        } catch (e) {
          /* ignore */
        }
      },

      scheduleCartValidationFromItemsChanged() {
        this.lastValidationTrigger = 'cart-items-changed';
        if (this.cartChangeTimer) {
          clearTimeout(this.cartChangeTimer);
        }
        this.cartChangeTimer = setTimeout(() => {
          this.cartChangeTimer = null;
          this.validateCart(false);
        }, 0);
      },

      holdGate() {
        if (this.gateHeld) return;
        this.gateHeld = true;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-hold', { detail: { id: this.gateId } }));
      },

      releaseGate() {
        if (!this.gateHeld) return;
        this.gateHeld = false;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-release', { detail: { id: this.gateId } }));
      },

      getSavedCep() {
        try {
          var raw = localStorage.getItem('haoma-cep-express');
          if (!raw) return '';
          var data = JSON.parse(raw);
          return data && data.cep ? String(data.cep) : '';
        } catch (e) {
          return '';
        }
      },

      getWarnedCep() {
        try {
          return sessionStorage.getItem(this.warnedCepKey) || '';
        } catch (e) {
          return '';
        }
      },

      markCepWarned(cep) {
        this.previousCep = cep;
        try {
          sessionStorage.setItem(this.warnedCepKey, String(cep || ''));
        } catch (e) {
          /* ignore */
        }
      },

      // Fora da página /cart o aviso é um modal bloqueante: ele só pode abrir
      // sozinho quando o CEP muda. Sem isso reabre a cada navegação.
      // Na própria página de carrinho o popup substitui o bloco fixo, então ele
      // pode abrir na primeira visita; o descarte por carrinho+CEP ainda vale.
      canAutoShow(cep) {
        if (this.variant !== 'popup' || this.alwaysAutoShow) return true;
        return String(cep || '') !== this.getWarnedCep();
      },

      getDismissState(cart, cep) {
        var skus = [];
        var items = this.getCartLineItems(cart);
        for (var i = 0; i < items.length; i++) {
          var sku = String(items[i].sku);
          if (skus.indexOf(sku) < 0) skus.push(sku);
        }
        return { cep: String(cep || ''), skus: skus.sort() };
      },

      // A dispensa continua valendo enquanto o cliente só mexe na quantidade ou
      // remove itens: o aviso só volta com um SKU novo no carrinho ou outro CEP.
      isDismissed(state) {
        try {
          var raw = sessionStorage.getItem(this.config.dismissStorageKey || 'haoma-express-cart-warning-dismissed');
          if (!raw) return false;
          var saved = JSON.parse(raw);
          if (!saved || saved.cep !== state.cep || !saved.skus || !saved.skus.length) return false;
          for (var i = 0; i < state.skus.length; i++) {
            if (saved.skus.indexOf(state.skus[i]) < 0) return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      },

      persistDismiss(state) {
        try {
          sessionStorage.setItem(
            this.config.dismissStorageKey || 'haoma-express-cart-warning-dismissed',
            JSON.stringify({ cep: state.cep, skus: state.skus, dismissedAt: Date.now() })
          );
        } catch (e) {
          /* ignore */
        }
      },

      async fetchCart() {
        var response = await fetch(Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('cart');
        return response.json();
      },

      getCartLineItems(cart) {
        return (cart.items || []).filter(function (item) {
          if (!item || !item.sku) return false;
          if (item.properties && item.properties._gift === 'true') return false;
          return true;
        });
      },

      async checkAvailability(skus) {
        if (!window.haomaExpressAvailability || typeof window.haomaExpressAvailability.check !== 'function') {
          return {};
        }
        return window.haomaExpressAvailability.check(skus);
      },

      async validateCart(force) {
        if (!this.config.enabled) {
          this.applyForceStandard(false, 'cart');
          this.show = false;
          this.releaseGate();
          return;
        }

        var cep = this.getSavedCep();
        if (!cep) {
          this.applyForceStandard(false, 'cart');
          this.show = false;
          this.releaseGate();
          return;
        }

        var canAutoShow = this.canAutoShow(cep);

        // Adição de item, troca de CEP e mudança no carrinho podem disparar
        // validações simultâneas; só a última pode decidir o estado do aviso.
        var token = ++this.validationToken;
        var isStale = () => token !== this.validationToken;

        this.holdGate();
        this.loading = true;

        try {
          var cart = await this.fetchCart();
          if (isStale()) return;

          var items = this.getCartLineItems(cart);
          if (!items.length) {
            await this.maybeClearForceStandard(cart);
            this.markCepWarned(cep);
            this.show = false;
            this.unavailableItems = [];
            this.releaseGate();
            return;
          }

          var skus = items.map(function (item) { return String(item.sku); });
          var availability = await this.checkAvailability(skus);
          if (isStale()) return;

          var unavailable = items.filter(function (item) {
            return availability[String(item.sku)] !== true;
          }).map(function (item) {
            return {
              key: item.key,
              sku: item.sku,
              variantId: item.variant_id,
              productId: item.product_id,
              quantity: item.quantity,
              title: item.product_title || item.title,
              image: item.image || (item.featured_image && item.featured_image.url) || ''
            };
          });

          // O aviso existe para alertar a perda da expressa: só faz sentido
          // quando o carrinho ainda tem ao menos um item elegível. Se todos já
          // são padrão, não há prazo turbo a proteger.
          var hasExpressItem = items.some(function (item) {
            return availability[String(item.sku)] === true;
          });

          this.markCepWarned(cep);

          if (!unavailable.length || !hasExpressItem) {
            await this.maybeClearForceStandard(cart);
            this.show = false;
            this.unavailableItems = [];
            this.releaseGate();
            return;
          }

          var dismissed = this.isDismissed(this.getDismissState(cart, cep));

          // Prazo já aceito para este CEP: o aviso não reabre ao adicionar
          // produtos, só volta se o CEP mudar ou o carrinho voltar a ser
          // elegível para entrega expressa.
          if (this.isAcceptedForCep(cep)) {
            this.applyForceStandard(true);
            this.show = false;
            this.unavailableItems = [];
            this.releaseGate();
            return;
          }

          if (!force && dismissed) {
            this.applyForceStandard(true);
            this.show = false;
            this.unavailableItems = [];
            this.releaseGate();
            return;
          }

          // Ainda não aceitou: só badges do carrinho até a decisão.
          this.applyForceStandard(true, 'cart');

          // Fora do /cart, o popup também precisa abrir quando a situação muda
          // por adição de item (e não só por troca de CEP).
          if (!force && !canAutoShow && this.lastValidationTrigger !== 'cart-items-changed') {
            this.show = false;
            this.unavailableItems = [];
            this.releaseGate();
            return;
          }

          this.unavailableItems = unavailable;
          this.show = true;
        } catch (e) {
          this.releaseGate();
          /* fail silently */
        } finally {
          this.loading = false;
          // Uma execução obsoleta nunca chega ao ponto de decidir o aviso:
          // sem isso o gate ficaria preso e travaria os outros popups.
          if (isStale() && !this.show) this.releaseGate();
        }
      },

      onCepUpdated() {
        var newCep = this.getSavedCep();
        if (!newCep || newCep === this.previousCep) return;

        this.holdGate();

        this.clearAccepted();

        var self = this;
        setTimeout(function () {
          self.forceStandardDelivery(false).then(function () {
            self.validateCart(true);
          });
        }, 350);
      },

      async dismissCurrentCart() {
        var cep = this.getSavedCep();
        try {
          var cart = await this.fetchCart();
          this.persistDismiss(this.getDismissState(cart, cep));
        } catch (e) {
          /* ignore */
        }
        this.markCepWarned(cep);
      },

      async dismiss() {
        await this.dismissCurrentCart();
        this.markAccepted(this.getSavedCep());
        await this.forceStandardDelivery(true);
        this.show = false;
        this.releaseGate();
      },

      async removeItems() {
        if (this.removing || !this.unavailableItems.length) return;

        this.removing = true;

        var helper = window.Alpine && Alpine.store('xCartHelper');
        var updates = {};
        this.unavailableItems.forEach(function (item) {
          updates[item.key] = 0;
        });

        var body = { updates: updates };
        if (helper) {
          body.sections = helper.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        try {
          // Sem esperar a fila, a remoção pode atropelar a reconciliação de
          // brindes disparada pela adição que abriu o aviso.
          if (helper) await helper.waitForCartUpdate();
          window.updatingCart = true;

          var response = await fetch(Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          if (!response.ok) throw new Error('cart-update');

          var cart = await response.json();

          this.unavailableItems = [];
          this.show = false;

          // Removemos todos os itens sem expressa: os que sobraram voltam
          // a exibir badge de entrega expressa na loja e no carrinho.
          await this.maybeClearForceStandard(cart);

          this.releaseGate();

          if (helper) {
            await helper.reRenderSections(cart.sections || null);
            helper.currentItemCount = cart.item_count;
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { detail: { cart: cart } }));
          window.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { detail: { cart: cart } }));
        } catch (e) {
          /* fail silently */
        } finally {
          window.updatingCart = false;
          // O drawer esconde a lista enquanto o mini carrinho está em loading:
          // deixar essa flag presa faria os itens sumirem até um recarregamento.
          if (window.Alpine && Alpine.store('xMiniCart')) {
            Alpine.store('xMiniCart').loading = false;
          }
          this.removing = false;
        }
      }
    }));
  };

  if (window.Alpine) {
    registerExpressCartWarning();
  } else {
    document.addEventListener('alpine:init', registerExpressCartWarning);
  }
}
